const Pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export class ValidGuid {
  public static create(value?: string | null) {
    return value && Pattern.test(value) ? new ValidGuid(value) : new InvalidGuid(value);
  }

  private constructor(public readonly value: string) {}
}

export class InvalidGuid {
  public readonly validationError = 'Invalid Guid';

  public constructor(public readonly value: string | undefined | null) {}
}
